import { Box, CircularProgress, Typography } from "@mui/material"
import { createFileRoute } from "@tanstack/react-router"
import type { FC } from "react"

import { TransferFormPage } from "@/screens/Inventory/subfeatures/Transfers/components"
import { useGetTransfer } from "@/screens/Inventory/subfeatures/Transfers/hooks/useGetTransfer"

const TransferEditPage: FC = () => {
  const { transferId } = Route.useParams()
  const { transfer, isFetching } = useGetTransfer(transferId)

  if (!transfer) {
    return (
      <Box className='flex h-full items-center justify-center'>
        {isFetching ? <CircularProgress size={48} /> : <Typography>Transfer not found</Typography>}
      </Box>
    )
  }

  return (
    <TransferFormPage
      type={transfer.transferType}
      sourceWarehouseArea={transfer.sourceWarehouseArea}
      transfer={transfer}
    />
  )
}

export const Route = createFileRoute("/app/inventory/transfers/$transferId/edit")({
  component: TransferEditPage,
})
